// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"d3b80b1a","453":"c5951efe"}[chunkId] + ".chunk.js";
};